import { LevelRow } from '../types/survey';

export type SanityWarning = {
  rowIndex: number;
  message: string;
};

function num(v: string): number | null {
  if (!v || v.trim() === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function checkLevelSanity(rows: LevelRow[]): SanityWarning[] {
  const warnings: SanityWarning[] = [];

  rows.forEach((row, index) => {
    const bs = num(row.bs);
    const isv = num(row.is);
    const fs = num(row.fs);
    const hi = num(row.hi);
    const rl = num(row.rl);

    if (bs !== null && bs > 10) {
      warnings.push({
        rowIndex: index + 1,
        message: `BS ${bs.toFixed(3)} looks too high. Check OCR/input.`
      });
    }

    if (isv !== null && isv > 10) {
      warnings.push({
        rowIndex: index + 1,
        message: `IS ${isv.toFixed(3)} looks too high. Check OCR/input.`
      });
    }

    if (fs !== null && fs > 10) {
      warnings.push({
        rowIndex: index + 1,
        message: `FS ${fs.toFixed(3)} looks too high. Check OCR/input.`
      });
    }

    if (hi !== null && rl !== null && isv !== null) {
      const expectedRL = hi - isv;

      if (Math.abs(expectedRL - rl) > 0.005) {
        warnings.push({
          rowIndex: index + 1,
          message: `IS RL mismatch. Expected ${expectedRL.toFixed(3)}, found ${rl.toFixed(3)}.`
        });
      }
    }

    if (hi !== null && rl !== null && fs !== null) {
      const expectedRL = hi - fs;

      if (Math.abs(expectedRL - rl) > 0.005) {
        warnings.push({
          rowIndex: index + 1,
          message: `FS RL mismatch. Expected ${expectedRL.toFixed(3)}, found ${rl.toFixed(3)}.`
        });
      }
    }

    if (index > 0) {
      const prevRL = num(rows[index - 1].rl);

      if (prevRL !== null && rl !== null) {
        const diff = Math.abs(rl - prevRL);

        if (diff > 5) {
          warnings.push({
            rowIndex: index + 1,
            message: `RL jump ${diff.toFixed(3)} m from previous row. Check reading/CP.`
          });
        }
      }
    }
  });

  return warnings;
}
